import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Schedule from './pages/Schedule';
import Club from './pages/Club';
import Pricing from './pages/Pricing';
import AppPage from './pages/App';
import Shop from './pages/Shop';
import { ScrollToTop } from './components/ScrollToTop';

// Placeholder components for other pages to prevent errors
const Placeholder = ({ title }: { title: string }) => (
  <div className="min-h-screen bg-black text-white flex items-center justify-center flex-col p-4">
    <h1 className="text-5xl font-black text-nolimit-red mb-4">{title}</h1>
    <p className="text-gray-400 text-xl">Cette page est en cours de construction.</p>
    <a href="/" className="mt-8 text-white underline hover:text-nolimit-red">Retour à l'accueil</a>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/club" element={<Club />} />
        <Route path="/app" element={<AppPage />} />
        <Route path="/planning" element={<Schedule />} />
        <Route path="/tarifs" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/boutique" element={<Shop />} />
        <Route path="/avis" element={<Placeholder title="AVIS MEMBRES" />} />
        <Route path="/faq" element={<Placeholder title="FAQ" />} />
      </Routes>
    </Router>
  );
}

export default App;
